import setVuePrototypeData from '@/framework/plugins/setVuePrototypeData';
import setVuePrototypeMethods from '@/framework/plugins/setVuePrototypeMethods';

import setFilter from '@/framework/plugins/setFilter';
import setMixinMethods from '@/framework/plugins/setMixinMethods';
import setComponent from '@/framework/plugins/setComponent';

let projectPlugin = {};

projectPlugin.install = function (Vue, options) {
  Vue.use(setVuePrototypeData);
  Vue.use(setVuePrototypeMethods);
  Vue.use(setFilter);
  Vue.use(setMixinMethods);
  Vue.use(setComponent);
};

export default projectPlugin;
